import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { UserAuthenticationService } from '../services/user-authentication.service';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationGuard implements CanActivate {
  constructor(
    private router: Router,
    private userAuthenticationService: UserAuthenticationService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.userAuthenticationService.isUserAuthenticated) {
      return true;
    }

    const tokenFromUrl = route.queryParamMap.get('token');
    if (tokenFromUrl) {
      const isValid = this.userAuthenticationService.validateTokenAndAuthenticate(tokenFromUrl);

      if (isValid) {
        return true;
      }
    }

    this.router.navigate(['/login'], {
      queryParams: { returnUrl: state.url },
    });

    return false;
  }
}
